<template>
  <div
    class="m-card-outer"
    :title="viewInfo.name"
  >
    <div class="m-card-head">
      <span class="u-data-view-tt">{{viewInfo.name}}</span>
      <el-button
        type="iconButton"
        icon="u-icon h-icon-edit"
        @click="handleEdit(viewInfo.id)"
      ></el-button>
      <el-button
        type="iconButton"
        icon="u-icon h-icon-password_visible"
        @click="handlePreview(viewInfo.id)"
      ></el-button>
      <el-button
        type="iconButton"
        icon="u-icon h-icon-delete"
        @click="handleDelete(viewInfo.id)"
      ></el-button>
    </div>
  </div>
</template>

<script>
import configuration from 'api/config'
import Api from 'api/api'
export default {
  props: {
    viewInfo: {
      type: Object,
      default: () => {
        return { name: '' }
      }
    }
  },
  methods: {
    handlePreview (id) {
      window.open(`${configuration.context}/data-view?key=${id}`)
    },
    handleEdit (id) {
      window.open(`${configuration.context}/management/data-view-configuration?branch=full&key=${id}`)
    },
    handleDelete (id) {
      this.$confirm(this.$t('management.dataView.delete_confirm'), {
        confirmButtonText: this.$t('common.confirmBtn_text'),
        cancelButtonText: this.$t('common.cancelBtn_text'),
        type: 'question'
      }).then(() => {
        Api.dataView.delDataView({ boardId: id }).then(res => {
          this.$message({
            type: 'success',
            message: this.$t('common.del_success')
          })
          this.$emit('refresh')
        }).catch(err => {
          this.$message.error(err.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.cancel_del')
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.m-card-outer {
  float: left;
  width: 260px;
  height: 160px;
  margin: 0 6px 16px;
  border-radius: 4px;
  border-radius: 8px;
  background: #f5f5f5;
  background-image: url("../../../assets/images/pic_kanban.png");
  background-repeat: no-repeat;
  background-size: contain;
  .m-card-head {
    width: 100%;
    height: 32px;
    box-sizing: border-box;
    padding: 0 8px;
    text-align: right;
    .u-data-view-tt {
      display: block;
      text-align: left;
      float: left;
      width: calc(~"100% - 106px");
      height: 32px;
      font-size: 12px;
      line-height: 32px;
      color: #4c4c4c;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-button + .el-button {
      margin-left: 0px;
    }
    .u-icon {
      font-size: 14px;
    }
  }
}
</style>
